import { TFunction } from 'i18next'

export const formatGramsToHumanWeight = ({
  weight,
  t,
  showDecimal,
  alwaysKilo,
}: {
  weight: number;
  t: TFunction;
  showDecimal?: boolean | number;
  alwaysKilo?: boolean;
}) => {
  if (alwaysKilo) {
    const shortWeight = (weight / 1000)
      .toFixed(
        typeof showDecimal === 'number' ? showDecimal : showDecimal ? 3 : 0,
      )
      .toString()
      .replace('.', ',')
    return `${shortWeight} ${t('weight.kg')}`
  }
  if (weight < 1000) {
    return `${weight} ${t('weight.gr')}`
  }
  else if (weight < 1000000) {
    const shortWeight = (weight / 1000).toFixed(0).toString().replace('.', ',')
    return `${shortWeight} ${t('weight.kg')}`
  }
  else {
    const shortWeight = (weight / 1000000)
      .toFixed(0)
      .toString()
      .replace('.', ',')
    return `${shortWeight} ${t('weight.ton')}`
  }
}
